<template>
  <div class="interpreter_statistics">

    <main class="main" style="height:100%">

      <!-- 生产table -->
      <template>
        <el-table v-loading="loading" :header-cell-style="{background:'#EEF5FF',color:'#566087'}" ref="projectTable"
          tooltip-effect="dark" style="width:100%" :data="interpreterData" height="100%">
          <template slot="empty">
            <div id="notDate">
              <img src="../../assets/imgs/memory/no_data.png" alt />
              <p>暂无数据</p>
            </div>
          </template>

          <el-table-column align="center" label="序号" min-width="40">
            <template slot-scope="scope">
              <p>{{scope.$index + 1}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="译   员" :show-overflow-tooltip="true" prop="username">
            <template slot-scope="scope">
              <div class="name-active" @click="toDetailStatistics(scope.row)">
                {{ scope.row.username}}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="翻译字数" :show-overflow-tooltip="true" prop="transWordNum">
          </el-table-column>
          <el-table-column align="center" label="翻译速度（字/分钟）" :show-overflow-tooltip="true" prop="transCostTime">
            <template slot-scope="scope">
              <div>
                {{ scope.row.transCostTime ? Math.round((scope.row.transWordNum/(scope.row.transCostTime/60))) : scope.row.transCostTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="准确度（平均）" :show-overflow-tooltip="true" prop="accuracyScore">
            <template slot-scope="scope">
              <div>
                {{ scope.row.accuracyScore===null ? "--" : scope.row.accuracyScore}}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流畅度（平均）" :show-overflow-tooltip="true" prop="fluencyScore"
            min-width="123">
            <template slot-scope="scope">
              <div>
                {{ scope.row.fluencyScore===null ? "--" : scope.row.fluencyScore}}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="paging_device">
          <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
            :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
            @current-change="handleCurrentChange"></el-pagination>
        </div>

      </template>

      <!-- 议员业绩table -->

    </main>
  </div>
</template>

<script>
// import ExportJsonExcel from 'js-export-excel';

export default {
  name: "InterpreterStatistics",
  data() {
    return {
      number: 0, // 页面左上角总字数
      interpreterData: [],
      totalRows: 0,//总条数
      currentPage: 1,// 当前页码 
      loading: true,//Loding 加载图  生产报表

    };
  },
  components: {},
  mounted() {
    this.getScoreAndCost(this.currentPage)
  },
  created() {

  },
  methods: {
    toDetailStatistics(row) {
      this.$router.push({ path: "/home/projectHome/personageStatistics", query: { id: row.userId,name:row.username } })
    },
    //currentPage 页面改变时会触发
    handleCurrentChange(val) {
      this.loading = true
      this.getScoreAndCost(val)

    },
    // 获取列表
    getScoreAndCost(page, rows = 20) {
      sessionStorage.setItem("myCurrentPage", page); // 将页码存sessionStorage，刷新还在当前页   生产
      let that = this
      that.loading = false
      let filter = {
        companyCode: localStorage.myCompanyCode,
        platformType: this.$platformType
      }
      return this.catReq1Service('/api/v1/taskScore/queryPageOfScoreAndCost', {
        filter,
        page,
        rows,
        // sort: {},
      })
        .then(function (response) {
          that.loading = false;
          if (!response.success) {
            return []
          }
          that.interpreterData = response.list
          that.totalRows = response.totalRows || 0
          return response.list
        })
        .catch(function (error) {
        });
    },


  },

};
</script>
<style lang="less" scoped>
.interpreter_statistics {
  overflow: hidden;
  height: 100%;
  .retbtn {
    width: 48px;
    height: 30px;
    background: rgba(102, 102, 102, 1);
    color: #fff;
    position: absolute;
    left: 50px;
    top: 10px;
    line-height: 30px;
    font-size: 18px;
  }
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    span {
      float: left;
      margin-left: 50px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
    }
    p {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  main {
    // height: 100%;
    // // width: 1660px;
    // //position: relative;
    // //min-height: 100%;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    // border-radius: 6px;
    // margin-top: 31px;
    // padding: 0 20px;
    h3 {
      //   text-align: left;
      height: 30px;
      padding-top: 12px;
      div {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        width: 92px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titActive {
        border-bottom: 1px solid #0288d2;
        color: #0288d2;
      }
    }
    .cell input {
      width: 54px;
    }
    #notDate {
      // 暂无数据
      margin-top: 80px;
    }

    
    .paging_device {
      position: absolute;

      right: 1.04vw;
      bottom: 0.54vw;
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    .tabTit {
      /deep/.el-table__body-wrapper {
        color: red;
        display: none;
        overflow-y: auto;
        height: calc(100% - 180px) !important;
      }
      .el-table__body-wrapper .is-scrolling-none {
        overflow-y: auto;
        height: calc(100% - 180px);
      }
      /deep/.has-gutter {
        tr {
          th {
            border: 0px;
          }
        }
      }
    }

    .tabMain {
      /deep/.has-gutter {
        tr {
          background-color: rgba(224, 237, 252, 1) !important;
          th:nth-child(1) {
            border-left: 1px solid #ebeef5;
          }
          th {
            border-right: 1px solid #ebeef5;
            background-color: rgba(224, 237, 252, 1) !important;
          }
        }
      }
    }
    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      border-right: 1px solid #ebeef5;
      padding: 0px !important;
      height: 45px;
    }
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center !important;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
    }
    // /deep/.el-table td:nth-child(3) {
    //   text-align: left;
    // }
    // /deep/.el-table td:nth-child(4) {
    //   text-align: left;
    // }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    #notDate {
      // 暂无数据
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    .el-table::before{
      height: 0px;
    }
    /deep/.el-table {
      padding-top: 10px;
      .el-table__empty-block {
        height: 90% !important;
      }
      border: 0px;
      height: 100%;
      // .el-table__body-wrapper {
      //   color: red;
      //   display: none;
      //   overflow-y: auto;
      //   height: calc(100% - 180px);
      // }
      // height: calc(100% - 129px);
      overflow: auto;
      //   width: 1620px;
      // .ass {
      //   border: 0px;
      //   padding: 5px;
      //   background: transparent;
      // }
      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 180px) !important;
      }
      .name-active:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  /deep/.el-pager li {
      // 页码样式
      min-width: 30px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      background: transparent;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
    }

    /deep/.el-pagination button {
      // 页码上下页样式
      width: 68px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      line-height: 30px;
      font-size: 14px;
      background: transparent;
      color: rgba(102, 102, 102, 1);
      font-weight: 400;
    }
    /deep/.el-pagination button:hover {
      border: 1px solid rgba(128, 128, 128, 1);
    }
    /deep/.el-pagination button:active {
      background: rgba(224, 237, 252, 1);
      border: 1px solid rgba(187, 187, 187, 1);
    }
    // .page {
    //   // margin-top: 30px;
    //   // float: right;
    //   position: absolute;
    //   bottom: 0px;
    //   left: 0px;
    //   right: 0px;
    //   bottom: 0px;
    //   margin: auto;
    // }
    /* 页码样式结束 */
}
</style>
<style lang="less">
</style>